<template>
    <div class="text-sm">
        <div
            v-if="type == 'success'"
            class="p-3 bg-green-50 border border-green-600 text-green-900 rounded-lg2"
        >
            <div class="flex items-center justify-start gap-2">
                <Icon
                    name="circle-check"
                    class="w-4 h-4 text-green-900"
                />
                <span class="font-semibold">{{ title }}</span>
            </div>
            <div class="mt-2">
                <slot />
            </div>
        </div>

        <div
            v-if="type == 'info'"
            class="p-3 bg-blue-50 border border-blue-500 text-blue-900 rounded-lg2"
        >
            <div class="flex items-center justify-start gap-2">
                <Icon
                    name="info-circle"
                    class="w-4 h-4 text-blue-900"
                />
                <span class="font-semibold">{{ title }}</span>
            </div>
            <div class="mt-2">
                <slot />
            </div>
        </div>

        <div
            v-if="type == 'warning'"
            class="p-3 bg-yellow-50 border border-yellow-500 text-yellow-900 rounded-lg2"
        >
            <div class="flex items-center justify-start gap-2">
                <Icon
                    name="alert"
                    class="w-4 h-4 text-yellow-900"
                />
                <span class="font-semibold">{{ title }}</span>
            </div>
            <div class="mt-2">
                <slot />
            </div>
        </div>

        <div
            v-if="type == 'danger'"
            class="p-3 bg-red-50 border border-red-600 text-red-900 rounded-lg2"
        >
            <div class="flex items-center justify-start gap-2">
                <Icon
                    name="alert"
                    class="w-4 h-4 text-red-900"
                />
                <span class="font-semibold">{{ title }}</span>
            </div>
            <div class="mt-2">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        type: {
            type: String as PropType<'success' | 'info' | 'warning' | 'danger'>,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    })
</script>
